import axios from 'axios';
import informationStore from 'utils/informationDB';
import offlineStore from 'utils/OfflineDB';
import offlineTrfStore from 'utils/offlineTrfStoreDB';
import { set, entries, clear } from 'idb-keyval';
import _ from 'lodash';
import { APIEndpoints } from 'helpers/APILists';
import { HOME_ACTIONS, INFO_PAGE } from './Home.constants';
import { MESSAGE_TYPE } from '../../common/common.constants';
import { trackErrors } from '../Admin/AdminComponents/helper';
import { formatDateToUTC } from 'helpers/DateFormatter';

export function exampleAction(text) {
  return dispatch => {
    dispatch({
      type: 'AUTH_SUCCESS',
      payload: { success: true },
      meta: { message: text }
    });
  };
}

export const setCurrentView = (view) => ({
  type: HOME_ACTIONS.SET_CURRENT_VIEW,
  payload: { currentView: view }
});

export const setPreviousScreen = (screen) => ({
  type: HOME_ACTIONS.SET_PREVIOUS_SCREEN,
  payload: { previousScreen: screen },
});

export const getAllRegionData = () => async (dispatch, getState) => {
  const { Home: { bpRegionName, selectedAssetName } } = getState();
  dispatch({
    type: HOME_ACTIONS.HOME_ACTIONS_GET_ALL_BP_REGION_DATA_PENDING,
    payload: {}
  });
  axios.get(`${APIEndpoints.HOME_GetBPRegionAssets}/${bpRegionName}`)
    .then((res) => {
      for (const key in localStorage) {
        if (key.includes('-image')) {
          localStorage.removeItem(key);
        }
      }
      const regionDetails = res.data;
      const regionName = regionDetails[0]?.BpRegion.toLowerCase();
      const groupNameList = _.uniq(regionDetails.map(x => x.MratGroup));
      const assetListWithoutImageButKey = regionDetails.map((data) => {
        localStorage.setItem(`${data.BpSiteName.toUpperCase()}-image`, `${data.AssetImg}`);
        return {
          ...data,
          AssetImg: `${data.BpSiteName.toUpperCase()}-image`
        };
      });
      dispatch({
        type: HOME_ACTIONS.HOME_ACTIONS_GET_ALL_BP_REGION_DATA_SUCCESS,
        payload: {
          regionDetails: assetListWithoutImageButKey,
          regionName
        }
      });
      if (groupNameList.length === 1 && !selectedAssetName) {
        dispatch(saveGroupName(groupNameList[0]));
      }
      if (regionName) {
        dispatch(getDetailsByRegion(regionName));
      }
    })
    .catch((err) => {
      dispatch({
        type: HOME_ACTIONS.HOME_ACTIONS_GET_ALL_BP_REGION_DATA_FAILURE,
        payload: {},
        meta: { messageType: MESSAGE_TYPE.ERROR, message: err.message, exception: err }
      });
    });
};

export const getBarrierAndWorkTypeData = () => async (dispatch, getState) => {
  const { Home: { selectedWorkType } } = getState();
  axios.get(APIEndpoints.ADMIN_GetBarrierTypeMappingDetails)
    .then((res) => {
      const allBarrierTypeList = res.data
        .filter((item) => item.OrderIndex > 0 && item.Status === 'Active')
        .map((item) => ({
          BarrierType: item.BarrierType,
          OrderIndex: item.OrderIndex,
          WorkType: item.WorkType,
          DefaultBarrierType: Boolean(item.DefaultBarrierType)
        }));
      const selectedBarrierType = allBarrierTypeList.find((data) => data.WorkType.toLowerCase() === selectedWorkType.toLowerCase() && data.DefaultBarrierType)
        ?.BarrierType.toLowerCase();
      const barrierTypeList = [...new Set(allBarrierTypeList.filter((data) => data.WorkType.toLowerCase() === selectedWorkType.toLowerCase())
        .sort((a, b) => a.OrderIndex - b.OrderIndex)
        .map((item) => item.BarrierType)
      )];
      const workTypeList = [...new Set(allBarrierTypeList.map((item) => item.WorkType))];
      dispatch({
        type: HOME_ACTIONS.HOME_ACTIONS_GET_ALL_BARRIER_AND_WORK_TYPE_DATA_SUCCESS,
        payload: {
          allBarrierTypeList,
          barrierTypeList,
          selectedBarrierType,
          workTypeList
        }
      });
    });
};

export const getDetailsByRegion = (regionName) => async (dispatch, getState) => {
  const { Home: { isNonMoFeatureEnabled, IsLateEntry } } = getState();
  const filterData = { Region: regionName };
  axios.post(APIEndpoints.GetAllRegionDisclaimer, filterData)
    .then((res) => {
      const disclaimer = res.data?.Disclaimer;
      const draftStatus = isNonMoFeatureEnabled || IsLateEntry ? false : res.data?.DraftStatus;
      const draftNotice = res.data?.DraftNotice;
      const draftDuration = res.data?.TimeInDraftAllowed;
      return dispatch({
        type: HOME_ACTIONS.HOME_ACTIONS_GET_DETAILS_BY_REGION,
        payload: {
          disclaimer,
          draftStatus,
          draftDuration,
          draftNotice
        }
      });
    });
};

export const getTrfMasterLists = () => async (dispatch, getState) => {
  axios.get(APIEndpoints.HOME_GetTrfMasterLists)
    .then((res) => {
      const trfMasterListData = res.data.map((item) => item);
      const trfMasterList = trfMasterListData.sort((a, b) => a.TrfId.localeCompare(b.TrfId, undefined, {
        numeric: true,
        sensitivity: 'base'
      }));
      return dispatch({
        type: HOME_ACTIONS.HOME_ACTIONS_GET_TRF_MASTER_LISTS_DATA_SUCCESS,
        payload: {
          trfMasterList
        }
      });
    });
};

export const getAllTagSelectionMOScreenData = () => async (dispatch, getState) => {
  const { Home: { selectedAssetName, selectedBarrierType, regionName, selectedWorkType } } = getState();
  const filterData = { Asset: selectedAssetName, Region: regionName, WorkType: selectedWorkType, BarrierType: selectedBarrierType };
  dispatch({
    type: HOME_ACTIONS.HOME_ACTIONS_GET_TAG_RECORDS_DATA_PENDING,
    payload: {
      tagsLoaded: false
    }
  });
  axios.post(APIEndpoints.GetVwSearchTag, filterData)
    .then((res) => {
      const tags = res.data.map((item) => item);
      // IF NO DATA then get data from the second url
      if (tags && tags.length > 0) {
        return dispatch({
          type: HOME_ACTIONS.HOME_ACTIONS_GET_TAG_RECORDS_DATA_SUCCESS,
          payload: {
            tags,
            tagsLoaded: true
          }
        });
      }
      return true;
    });
};

export const getAllTagBiSelectionMOScreenData = () => async (dispatch, getState) => {
  const { Home: { selectedAssetName, selectedBarrierType, regionName, selectedWorkType } } = getState();
  const filterData = { Asset: selectedAssetName, Region: regionName, WorkType: selectedWorkType, BarrierType: selectedBarrierType };
  dispatch({
    type: HOME_ACTIONS.HOME_ACTIONS_GET_TAG_BI_RECORDS_DATA_PENDING,
    payload: {
      tagsBiLoaded: false
    }
  });
  axios.post(APIEndpoints.GetVwSearchTagBi, filterData)
    .then((res) => {
      const tagsBi = res.data.map((item) => item);
      return dispatch({
        type: HOME_ACTIONS.HOME_ACTIONS_GET_TAG_BI_RECORDS_DATA_SUCCESS,
        payload: {
          tagsBi,
          tagsBiLoaded: true
        }
      });
    });
};

export const saveGroupName = (groupName) => (dispatch, getState) => {
  const { Home: { regionDetails } } = getState();
  const assetNameList = regionDetails.filter(x => x.MratGroup.toLowerCase() === groupName.toLowerCase()).map((item) => item.BpSiteAliasName.toUpperCase());
  dispatch({
    type: HOME_ACTIONS.HOME_SET_GROUP_NAME,
    payload: {
      selectedGroupName: groupName,
      assetNameList,
      selectedAssetName: '',
      selectedAssetAliasName: ''
    }
  });
};

export const saveAssetName = (assetName) => (dispatch, getState) => {
  const { Home: { regionDetails, selectedGroupName } } = getState();
  const assetDetails = regionDetails.find((item) => item.MratGroup.toUpperCase() === selectedGroupName.toUpperCase()
    && item.BpSiteAliasName.toUpperCase() === assetName.toUpperCase());
  dispatch({
    type: HOME_ACTIONS.HOME_SET_ASSET_NAME,
    payload: {
      selectedAssetAliasName: assetName,
      selectedAssetName: assetDetails?.BpSiteName.toLowerCase()
    }
  });
};

export const saveWorkType = (workType) => (dispatch, getState) => {
  const { Home: { allBarrierTypeList, selectedWorkType } } = getState();
  let updateSelectedBarrierType = allBarrierTypeList.find(
    (data) => data.WorkType.toLowerCase() === workType.toLowerCase() && data.DefaultBarrierType
  )?.BarrierType;
  const barrierTypeList = [...new Set(allBarrierTypeList.filter((data) => data.WorkType.toLowerCase() === workType.toLowerCase())
    .sort((a, b) => a.OrderIndex - b.OrderIndex)
    .map((item) => item.BarrierType)
  )];
  if (workType.toLowerCase() !== selectedWorkType.toLowerCase()) {
    updateSelectedBarrierType = updateSelectedBarrierType?.toLowerCase();
  }
  dispatch({
    type: HOME_ACTIONS.HOME_SET_WORK_TYPE_NAME,
    payload: {
      barrierTypeList,
      selectedWorkType: workType,
      selectedBarrierType: updateSelectedBarrierType
    }
  });
};

export const saveBarrierType = (barrierType) => (dispatch) => dispatch({
  type: HOME_ACTIONS.HOME_SET_BARRIER_TYPE_NAME,
  payload: {
    selectedBarrierType: barrierType
  }
});

export const saveUsersGroupDetails = (membergroupId) => async (dispatch) => {
  await axios.get(`${APIEndpoints.GetMratSecurityGroupById}/${membergroupId}`).then((res) => {
    const memberGroup = res.data;
    const bpRegionName = memberGroup?.BpRegion || 'No region found';
    return dispatch({
      type: HOME_ACTIONS.HOME_SET_USERSROLEANDREGION,
      payload: {
        bpRegionName,
        bpRegionNameAlias: memberGroup?.BpRegionAlias,
        userRole: memberGroup?.Role?.RoleName || 'cannot find your role',
        adGroupType: memberGroup?.AdGroupType,
        isNonMoFeatureEnabled: memberGroup.AdGroupType.Code.includes('NON-MO')
      },
    });
  });
};

export const saveUserLoginLogs = (userDetails) => async (dispatch, getState) => {
  const { Home: { isNonMoFeatureEnabled, adGroupType, bpRegionName } } = getState();
  const userData = {
    UserName: userDetails.userName,
    UserId: userDetails.userEmailId,
    BpRegion: bpRegionName,
    GroupName: userDetails.groupName,
    UserRole: userDetails.userRole,
    AdGroupType: adGroupType.Code,
    LoginTimeUtc: formatDateToUTC(new Date()),
    DeviceType: userDetails.isTablet ? 'Tablet' : 'Laptop',
    IsNonMoTrf: isNonMoFeatureEnabled,
  };
  try {
    await axios.post(APIEndpoints.AddUserLoginLog, userData);
    dispatch({
      type: HOME_ACTIONS.HOME_SET_USERSLOGINLOGS,
      payload: userData
    });
  } catch (error) {
    dispatch({
      type: HOME_ACTIONS.HOME_SET_USERSLOGINLOGS_ERROR,
      payload: error.message
    });
  }
};
export const cleanupHomeStates = () => (dispatch) => dispatch({
  type: HOME_ACTIONS.HOME_CLEANUP_NONESSENTAIL_STATES,
  payload: {
    selectedAssetName: ''
  },
});

export const getAllInfoDocuments = () => async (dispatch, getState) => {
  const { Home: { currentView } } = getState();
  dispatch({
    type: HOME_ACTIONS.INFOPAGE_GETDOCUMENTS_PENDING,
  });
  await axios.get(currentView !== INFO_PAGE.VIEW
    ? `${APIEndpoints.GetInformation}/${INFO_PAGE.USER}`
    : APIEndpoints.InfoDocuments).then((res) => {
      const activePDF = res.data.filter((data) => data.Pdfstatus);
      set('InformationPdf', activePDF, informationStore);
      dispatch({
        type: HOME_ACTIONS.INFOPAGE_GETDOCUMENTS_SUCCESS,
      });
    }).catch((err) => {
      dispatch({
        type: HOME_ACTIONS.INFOPAGE_GETDOCUMENTS_FAILURE,
        meta: { messageType: MESSAGE_TYPE.ERROR, message: err.message, exception: err }
      });
    });
};

export const updateMRATSyncInvalidationStatus = (localState) => (dispatch) => dispatch({
  type: HOME_ACTIONS.UPDATE_INVALIDATION_STATUS,
  payload: {
    syncInvalidationStatus: localState
  }
});

export const disableMRATSyncButton = (buttonStatus) => (dispatch) => dispatch({
  type: HOME_ACTIONS.UPDATE_SYNC_BUTTON_STATUS,
  payload: {
    syncButtonStatus: buttonStatus
  }
});

export const checkOfflineDataPresent = () => async (dispatch) => {
  const data = await entries(offlineStore);
  dispatch({
    type: HOME_ACTIONS.CHECK_OFFLINE_DATA_PRESENT,
    payload: {
      isOfflineDataPresent: data.length > 0
    }
  });
};

export const setDataLoaded = () => (dispatch) => dispatch({
  type: HOME_ACTIONS.SET_DATA_LOADED,
  payload: {
    isDataLoaded: true
  }
});

export const sendOfflineData = () => (dispatch, getState) => {
  const { AppData: { isMRATOnline }, Home: { selectedAssetAliasName, bpRegionNameAlias, draftStatus, isNonMoFeatureEnabled, IsLateEntry } } = getState();
  dispatch({
    type: HOME_ACTIONS.HOME_SET_DRAFT_LIST_STATUS,
    payload: { GetNonMoTrfList: false }
  });
  const nonMoTrfListEndpoint = (isNonMoFeatureEnabled || IsLateEntry) && APIEndpoints.GetNonMoTrfList;
  if (isMRATOnline) {
    const payload = {
      Asset: selectedAssetAliasName,
      Region: bpRegionNameAlias,
      IsLateEntry
    };
    const offlineDataStore = draftStatus ? APIEndpoints.GetInDraftTrfList : nonMoTrfListEndpoint;
    if (!offlineDataStore) {
      return;
    }
    clear(offlineTrfStore).then(async () => {
      try {
        const response = await axios.post(offlineDataStore, payload);
        const filteredDataLateEntry = response.data.filter(item => item.IsLateEntry === true);
        const filteredDataNonMo = response.data.filter(item => item.IsNonMoTrf === true);
        let res;
        if (IsLateEntry) {
          res = filteredDataLateEntry;
        } else if (isNonMoFeatureEnabled) {
          res = filteredDataNonMo;
        } else {
          res = response.data;
        }
        res.forEach((item) => {
          const Mi = item.F86Mi ?? item.F17Mi ?? '';
          const Mo = item.F20Mo ?? '';
          const uniqueFormName = item?.F91TrfId === 'P8-1' ? `${Mi}_${Mo}_${item.F2SapFloc}_P81` : `${Mi}_${Mo}_${item.F2SapFloc}`;
          const offlineTrfData = { body: item };
          offlineTrfData.body = item;
          set(`Forms_${uniqueFormName}`, offlineTrfData, offlineTrfStore);
        });
        dispatch({
          type: HOME_ACTIONS.HOME_SET_DRAFT_LIST_STATUS,
          payload: {
            GetNonMoTrfList: Array.isArray(res) && res.length > 0
          }
        });
      } catch (err) {
        trackErrors({
          messageType: MESSAGE_TYPE.ERROR,
          message: err.message,
          exception: err
        });
      }
    });
  } else {
    dispatch(checkOfflineTrfStoreWhenOffline());
  }
};

export const checkOfflineTrfStoreWhenOffline = () => async (dispatch, getState) => {
  const { AppData: { isMRATOnline } } = getState();
  if (!isMRATOnline) {
    const offlineData = await entries(offlineTrfStore);
    dispatch({
      type: HOME_ACTIONS.HOME_SET_DRAFT_LIST_STATUS,
      payload: {
        GetNonMoTrfList: offlineData.length > 0,
        offlineData
      }
    });
  }
};
export const fetchAlertNotification = () => (dispatch, getState) => {
  const { Home: { bpRegionNameAlias } } = getState();
  axios.get(APIEndpoints.ADMIN_GetAlertNotification)
    .then((response) => {
      const { data } = response;
      const toYmdNumber = (value) => {
        if (!value) return null;
        const d = new Date(value);
        const y = d.getFullYear();
        const m = d.getMonth() + 1;
        const day = d.getDate();
        return y * 10000 + m * 100 + day; // YYYYMMDD
      };

      const todayNum = toYmdNumber(new Date());

      const filtered = data.filter(a => {
        if (a.Status !== 'Active') return false;
        if (!(a.BpRegion === 'ALL' || a.BpRegionAlias === bpRegionNameAlias)) return false;
        const startNum = toYmdNumber(a.AlertStartDate);
        const endNum = toYmdNumber(a.AlertEndDate);
        // Inclusive range; null start/end treated as open bounds
        return (startNum <= todayNum) && (endNum >= todayNum);
      });

      dispatch({
        type: HOME_ACTIONS.SET_ALERTS_NOTIFICATION,
        payload: {
          alertsNotification: filtered
        }
      });
      dispatch({
        type: HOME_ACTIONS.SET_ALERT_NOTIFICATION_TOAST_VISIBLE,
        payload: {
          toastVisible: filtered.length > 0
        }
      });
    })
    .catch((err) => {
      dispatch({
        type: HOME_ACTIONS.SET_ALERTS_NOTIFICATION_ERROR,
        payload: {
          alertsNotification: []
        }
      });
      dispatch({
        type: HOME_ACTIONS.SET_ALERT_NOTIFICATION_TOAST_VISIBLE_ERROR,
        payload: {
          toastVisible: false
        }
      });
    });
};
export const fetchLateEntryMenuFlag = (bpRegionNameAlias) => axios.get(APIEndpoints.ADMIN_GetBpRegionDetails)
  .then((response) => {
    const { data } = response;
    const filtered = data.filter(
      a => a.BpRegionAlias === bpRegionNameAlias && a.IsLateEntry === true
    );
    return filtered.length > 0;
  })
  .catch(() => false);

export const setLateEntryStatus = (status) => (dispatch) => {
  dispatch({
    type: HOME_ACTIONS.SET_LATE_ENTRY_STATUS,
    payload: {
      IsLateEntry: status
    }
  });
};

export const setAnnouncementState = (userId, lastSeenAnnouncementId) => (dispatch) => {
  axios.post(APIEndpoints.SaveAnnouncementState, { UserId: userId, LastSeenAnnouncementId: lastSeenAnnouncementId })
    .then(() => {
      dispatch({
        type: HOME_ACTIONS.SET_ANNOUNCEMENT_STATE,
        payload: {
          unreadAnnouncementsCount: 0,
        }
      });
    });
};

export const getAnnouncementState = (userId) => (dispatch) => {
  const userData = { UserId: userId };
  axios.post(`${APIEndpoints.GetAnnouncementState}`, userData)
    .then((response) => {
      const { data } = response;
      dispatch({
        type: HOME_ACTIONS.GET_ANNOUNCEMENT_STATE,
        payload: {
          unreadAnnouncementsCount: data?.UnreadCount ?? 0,
        }
      });
    });
};
